import React, { useEffect, useState } from 'react'
import { CModal, CModalBody, CModalFooter, CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem, CFormLabel, CButton, CModalHeader, CModalTitle, CSpinner } from '@coreui/react'
import { FilePlus2, Plus, Trash } from 'lucide-react'
import Select from 'react-select'
import CustomDatePickingFormat from '../../components/shared/CustomDatePickingFormat'
import Graytextarea from '../../components/Graytextarea'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import { useIndexedDB } from '../../context/IndexedContext'
const ProviderIncidentTab = ({ diagnosis, showDataIfNoteIsFollowUp, saveTreatsShell, setAddedNewIncident, patientID = '', noteID, noteStructureRef, isAllotedToProvider, patientDiagnosis, noteCallType }) => {
  const [visible, setVisible] = useState(false)
  const [allDiagnosis, setAllDiagnosis] = useState([])
  const [date, setDate] = useState('')
  const [incidentRemark, setIncidentRemark] = useState('')
  const [tempModalIncidentRemark, setTempModalIncidentRemark] = useState('')
  const [toggleToAddIncidentRemark, setToggleToAddIncidentRemark] = useState(false)
  const [isAddingNewIncident, setIsAddingNewIncident] = useState(false)
  const [dbData, setDbData] = useState({})

  const { getHPIDiagnosisData, getAllMasterDiagnosis, getOfflineData, saveOfflineData, getProviderDetails, getOpenChartOfflineData, saveOpenChartOfflineData } = useIndexedDB()
  useEffect(() => {
    const fetchHPIMasterFromDB = async () => {
      const data = await getHPIDiagnosisData()
      setDbData(data)
    }
    fetchHPIMasterFromDB()
  }, [])

  const handleAddNewIncident = async () => {
    setIsAddingNewIncident(true)
    const findDiagnosisId = allDiagnosis?.find((item) => item.label === selectedDiagnosis)
    if (findDiagnosisId) {
      // let data = await SaveQuestionProvider('GET', '', 'Incident', findDiagnosisId?.value, '')
      // data = JSON.parse(data?.d)?.Data || []
      // const allParsedData = data.flatMap((item) => {
      //   try {
      //     const parsed = JSON.parse(item.questionData)
      //     return Array.isArray(parsed) ? parsed : []
      //   } catch (err) {
      //     console.error('Invalid JSON in questionData:', item.questionData)
      //     return []
      //   }
      // })
      let allParsedData = dbData[findDiagnosisId?.label]?.['Incident']?.questionData || []
      if (allParsedData.length > 0) {
        let isoString
        if (date) {
          const [month, day, year] = date?.split('/')
          const dateToIso = new Date(`${year}-${month}-${day}`)
          isoString = dateToIso.toISOString()
        }
        setAllIncidents([...allIncidents, { diagnosis: findDiagnosisId?.label, date: isoString, incidents: allParsedData }])

        setVisible(false)
        setDate('')
        setSelectedDiagnosis(null)
      } else {
        setIsAddingNewIncident(false)
        toast.error('No incident question are available', toastConfig)
        return
      }
    }
    setIsAddingNewIncident(false)
  }
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(null)
  const [allIncidents, setAllIncidents] = useState([])

  const handleDateChange = (e) => {
    setDate(e)
  }

  // useEffect(() => {
  //     const incidentObj = noteStructureRef?.current?.incident;
  //     if (!incidentObj) return;

  //     const allKeys = Object.keys(incidentObj);

  //     const structuredIncidents = allKeys
  //         .filter(key => Array.isArray(incidentObj[key]))
  //         .map(key => {
  //             const [diagnosis, date] = key.split("_");
  //             return {
  //                 diagnosis,
  //                 date,
  //                 incidents: incidentObj[key]
  //             };
  //         });

  //     setAllIncidents(structuredIncidents);
  // }, [noteStructureRef?.current]);

  useEffect(() => {
    const fetchIncidentData = async () => {
      // const incidentObj = noteStructureRef?.current?.incident
      // const incideRemrk = noteStructureRef?.current?.incidentRemark || ''
      if (!patientID) {
        return
      }
      let offlineIncidentData = noteCallType === 'OpenChart' ? await getOpenChartOfflineData() : await getOfflineData()
      let providerDetails = await getProviderDetails()
      const providerId = providerDetails?.ID
      let incideRemrk = offlineIncidentData?.[providerId]?.[patientID]?.currentNote?.data?.incidentRemark || ''
      offlineIncidentData = offlineIncidentData?.[providerId]?.[patientID]?.currentNote.data.incident
      if (offlineIncidentData) {
        const allKeys = Object.keys(offlineIncidentData)

        const structuredIncidents = allKeys
          .filter((key) => Array.isArray(offlineIncidentData[key]))
          .map((key) => {
            const [diagnosis, date] = key.split('_')
            return {
              diagnosis,
              date,
              incidents: offlineIncidentData[key],
            }
          })

        setAllIncidents(structuredIncidents)
      }

      setIncidentRemark(incideRemrk || '')
    }
    fetchIncidentData()
  }, [patientID])

  const [freetypeModal, setFreetypeModal] = useState(false)
  const [currentIncidentIndex, setCurrentIncidentIndex] = useState(null)
  const [newFreeTypeText, setNewFreeTypeText] = useState('')
  // fetch diagnosis
  const fetchDiagnosis = async () => {
    let diagnosisData = await getAllMasterDiagnosis()
    diagnosisData = diagnosisData?.Data
    // let diagnosisData = await GetDiagnosisData('')
    // diagnosisData = JSON.parse(diagnosisData.d)?.Data
    if (diagnosisData.length > 0) {
      const allDiagnosisOpt = diagnosisData
        .map((diagnosis) => {
          return {
            value: diagnosis.id,
            label: diagnosis.Name,
          }
        })
        ?.sort((a, b) => a.label.localeCompare(b.label))
      setAllDiagnosis(allDiagnosisOpt)
    }
  }

  const handleDeleteIncident = async (index, diagnosis, date) => {
    const incidentName = `${diagnosis}_${date}`

    const updatedIncidents = allIncidents.filter((_, i) => i !== index)

    let offlineData = noteCallType === 'OpenChart' ? await getOpenChartOfflineData() : await getOfflineData()
    let providerDetails = await getProviderDetails()

    const providerId = providerDetails?.ID
    if (!providerId || !patientID) return

    offlineData = offlineData || {}
    offlineData[providerId] = offlineData[providerId] || {}
    offlineData[providerId][patientID] = offlineData[providerId][patientID] || {}
    offlineData[providerId][patientID].currentNote = offlineData[providerId][patientID].currentNote || {}

    if (!offlineData[providerId][patientID].currentNote.data) {
      offlineData[providerId][patientID].currentNote.data = {}
    }
    const currentIncidents = { ...(offlineData?.[providerId]?.[patientID]?.currentNote?.data?.incident || {}) }

    delete currentIncidents[incidentName]

    noteStructureRef.current = {
      ...noteStructureRef.current,
      incident: currentIncidents,
    }

    setAllIncidents(updatedIncidents)

    offlineData[providerId][patientID].currentNote.data.incident = currentIncidents

    // await saveOfflineData(offlineData)
    noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(offlineData) : await saveOfflineData(offlineData)

    // await saveTreatsShell(false)

    setAddedNewIncident((p) => !p)

    toast.success('Incident Deleted', toastConfig)
  }

  useEffect(() => {
    fetchDiagnosis()
  }, [visible])

  const handleAddDataOffline = async () => {
    let offlineData = noteCallType === 'OpenChart' ? await getOpenChartOfflineData() : await getOfflineData()
    let providerDetails = await getProviderDetails()

    const providerId = providerDetails?.ID
    if (!providerId || !patientID) return

    offlineData = offlineData || {}
    offlineData[providerId] = offlineData[providerId] || {}
    offlineData[providerId][patientID] = offlineData[providerId][patientID] || {}

    offlineData[providerId][patientID].saveDraft = true

    offlineData[providerId][patientID].currentNote = offlineData[providerId][patientID].currentNote || {}

    if (!offlineData[providerId][patientID].currentNote.data) {
      offlineData[providerId][patientID].currentNote.data = {}
    }
    if (!offlineData[providerId][patientID].currentNote.data.incident) {
      offlineData[providerId][patientID].currentNote.data.incident = {}
    }

    allIncidents.forEach((item) => {
      const key = `${item.diagnosis}_${item.date}`
      offlineData[providerId][patientID].currentNote.data.incident[key] = item?.incidents || []
    })

    noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(offlineData) : await saveOfflineData(offlineData)
  }

  const handleAddFreeRemarkOffline = async (text) => {
    let offlineData = noteCallType === 'OpenChart' ? await getOpenChartOfflineData() : await getOfflineData()
    let providerDetails = await getProviderDetails()

    const providerId = providerDetails?.ID
    if (!providerId || !patientID) return

    offlineData = offlineData || {}
    offlineData[providerId] = offlineData[providerId] || {}
    offlineData[providerId][patientID] = offlineData[providerId][patientID] || {}
    offlineData[providerId][patientID].currentNote = offlineData[providerId][patientID].currentNote || {}

    if (!offlineData[providerId][patientID].currentNote.data) {
      offlineData[providerId][patientID].currentNote.data = {}
    }
    if (!offlineData[providerId][patientID].currentNote.data.incident) {
      offlineData[providerId][patientID].currentNote.data.incidentRemark = ''
    }

    offlineData[providerId][patientID].currentNote.data.incidentRemark = text

    noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(offlineData) : await saveOfflineData(offlineData)

    setAddedNewIncident((p) => !p)
  }

  const [savingIncidentLocally, setSavingIncidentLocally] = useState(false)
  const handleSave = async () => {
    setSavingIncidentLocally(true)
    await handleAddDataOffline()
    allIncidents.forEach((item) => {
      const key = `${item.diagnosis}_${item.date}`
      noteStructureRef.current = {
        ...noteStructureRef.current,
        incident: {
          ...noteStructureRef.current.incident,
          [key]: item?.incidents || [],
        },
      }
    })
    // await saveTreatsShell(false)
    setAddedNewIncident((p) => !p)
    toast.success('Saved')
    setSavingIncidentLocally(false)
    // setTimeout(() => {
    // }, 5000)
  }

  const updateIncidentAnswerById = (incidents, targetId, updater) => {
    return incidents.map((q) => {
      if (q.id === targetId) {
        return updater(q)
      } else if (q.options?.some((opt) => opt.linkedQuestion?.length)) {
        // find selected options
        let selectedOptions = []
        if (q.isMultiple) {
          const answerArray = q.answer ? q.answer.split(',').map((v) => v.trim()) : []
          selectedOptions = q.options.filter((opt) => answerArray.includes(opt.label))
        } else {
          selectedOptions = q.options.filter((opt) => opt.label === q.answer)
        }
        const linkedQuestions = Array.isArray(opt.linkedQuestion) ? opt.linkedQuestion : opt.linkedQuestion ? [opt.linkedQuestion] : []

        return {
          ...q,
          options: q.options.map((opt) => {
            if (linkedQuestions?.length) {
              const isSelected = selectedOptions.some((sel) => sel.label === opt.label)
              if (isSelected) {
                return {
                  ...opt,
                  linkedQuestion: updateIncidentAnswerById(linkedQuestions, targetId, updater),
                }
              }
            }
            return opt
          }),
        }
      }
      return q
    })
  }

  const updateIncidentAtIndex = (incidentIndex, questionId, updater) => {
    setAllIncidents((prevData) => {
      const newData = [...prevData]
      const incident = { ...newData[incidentIndex] }
      incident.incidents = updateIncidentAnswerById(incident.incidents, questionId, updater)
      newData[incidentIndex] = incident
      return newData
    })
  }

  const renderIncidentQuestion = (item, incidentIndex, questionIndex, parentPath = []) => {
    const currentPath = [...parentPath, item.id]
    return (
      <div key={item.id} className="mb-3">
        <div className="d-flex align-items-center gap-1 mb-2">
          <p className="mb-0">{currentPath.length === 1 ? questionIndex + 1 : '-'}.</p>
          <p className="mb-0">{item?.label}</p>
        </div>

        {item.type === 'dropdown' && (
          <Select
            className="react-select-container ui-react-select"
            classNamePrefix="react-select"
            isMulti={item?.isMultiple}
            menuIsOpen={item?.isMultiple ? undefined : item?.menuIsOpen}
            closeMenuOnSelect={!item?.isMultiple}
            onChange={(selected) => {
              let selectedValues = ''
              let selectedValuesArr = []
              if (item?.isMultiple) {
                selectedValuesArr = selected?.map((opt) => opt.value) || []
                selectedValues = selectedValuesArr.join(', ')
              } else {
                selectedValues = selected?.value || ''
              }
              updateIncidentAtIndex(incidentIndex, item.id, (q) => ({ ...q, answer: selectedValues }))

              // setAllIncidents((prevData) =>
              //     prevData.map((incidentBlock) => ({
              //         ...incidentBlock,
              //         incidents: updateIncidentAnswerById(incidentBlock.incidents, item.id, (q) => ({ ...q, answer: selectedValues })),
              //     })),
              // )
            }}
            value={item?.isMultiple ? (item?.answer && item.answer.trim() ? item.answer.split(',').map((val) => ({ value: val.trim(), label: val.trim() })) : []) : item?.answer && item.answer.trim() ? { value: item.answer, label: item.answer } : null}
            options={item.options?.map((opt) => ({ value: opt.label, label: opt.label })) || []}
            placeholder="Select an option"
            isClearable={!item?.isMultiple}
          />
        )}

        {item.type === 'input' && (
          <input
            type="text"
            className="form-control mt-2"
            value={item.answer || ''}
            // onChange={(e) => {
            //   const val = e.target.value
            //   setAllIncidents((prevData) =>
            //     prevData.map((incidentBlock) => ({
            //       ...incidentBlock,
            //       incidents: updateIncidentAnswerById(incidentBlock.incidents, item.id, (q) => ({ ...q, answer: val })),
            //     })),
            //   )
            // }}
            onChange={(e) => {
              updateIncidentAtIndex(incidentIndex, item.id, (q) => ({ ...q, answer: e.target.value }))
            }}
            style={{
              backgroundColor: '#191919',
              color: 'white',
              border: '0.6px solid #989898',
            }}
            placeholder="Enter your text"
          />
        )}

        {item.options?.map((opt) => {
          let isSelected = false
          if (item?.isMultiple) {
            const answerArray = item?.answer ? item.answer.split(',').map((v) => v.trim()) : []
            isSelected = answerArray.includes(opt.label)
          } else {
            isSelected = item?.answer === opt.label
          }
          const linkedQuestions = Array.isArray(opt.linkedQuestion) ? opt.linkedQuestion : opt.linkedQuestion ? [opt.linkedQuestion] : []

          return (
            isSelected &&
            linkedQuestions?.length > 0 && (
              <div key={`${opt.label}-${item.id}`} className="ml-3 mt-3 border-start ps-3">
                {linkedQuestions.map((nestedItem) => renderIncidentQuestion(nestedItem, incidentIndex, currentPath))}
              </div>
            )
          )
        })}

        <span className="d-block pt-2">
          <Graytextarea
            value={item.freeType || ''}
            // onChange={(e) => {
            //   const val = e.target.value
            //   setAllIncidents((prevData) =>
            //     prevData.map((incidentBlock) => ({
            //       ...incidentBlock,
            //       incidents: updateIncidentAnswerById(incidentBlock.incidents, item.id, (q) => ({ ...q, freeType: val })),
            //     })),
            //   )
            // }}
            onChange={(e) => {
              updateIncidentAtIndex(incidentIndex, item.id, (q) => ({ ...q, freeType: e.target.value }))
            }}
            height={'100px'}
            placeholder={'Freetype'}
            style={{
              border: '0.6px solid #989898',
              background: '#191919',
              height: '100px',
              color: 'white',
              fontSize: '14px',
            }}
          />
        </span>
      </div>
    )
  }

  return (
    <>
      <div
        className="d-flex gap-3 align-items-center px-4 mb-2 py-2"
        style={{
          background: '#191919',
        }}
      >
        <h7 className="fs-7  ">Incident</h7>
        <div className="d-flex gap-2 align-items-center">
          {isAllotedToProvider && (
            <CFormLabel
              className="d-flex mt-2 flex-column align-items-center justify-content-center shadow "
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                setVisible((p) => !p)
              }}
              style={{
                width: '30px',
                height: '30px',
                borderRadius: '20px',
                background: '#4363F2',
                cursor: 'pointer',
              }}
            >
              <Plus className="text-white" strokeWidth={2} size={15} />
            </CFormLabel>
          )}

          <CFormLabel
            className="d-flex mt-2 flex-column align-items-center justify-content-center shadow "
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              setToggleToAddIncidentRemark((p) => !p)
              setTempModalIncidentRemark(incidentRemark || '')
            }}
            style={{
              width: '30px',
              height: '30px',
              borderRadius: '20px',
              background: '#4363F2',
              cursor: 'pointer',
              color: 'white',
            }}
          >
            <FilePlus2 className="text-white " strokeWidth={2} size={15} />
          </CFormLabel>
        </div>
      </div>

      {incidentRemark && (
        <p style={{ whiteSpace: 'pre-line', color: 'gray' }} className="px-4">
          {incidentRemark || ''}
        </p>
      )}
      {!incidentRemark && allIncidents.length === 0 && (
        <div className="d-flex justify-content-start align-items-start text-muted" style={{}}>
          <div
            style={{
              fontSize: '14px',
              fontWeight: '300px',
              color: 'gray',
            }}
          >
            No Incident
          </div>
        </div>
      )}
      <CAccordion flush>
        {allIncidents.length > 0 &&
          allIncidents.map((incident, index) => {
            return (
              <CAccordionItem itemKey={1} className="mt-2">
                <CAccordionHeader className="">
                  <div className="d-flex justify-content-between w-100">
                    <div>
                      {incident?.diagnosis} -{' '}
                      {incident?.date &&
                        new Intl.DateTimeFormat('en-US', {
                          month: '2-digit',
                          day: '2-digit',
                          year: 'numeric',
                        }).format(new Date(incident.date))}
                    </div>
                    <div className="d-flex gap-2 align-items-center me-2">
                      <span
                        className=""
                        onClick={(e) => {
                          e.stopPropagation()
                          e.preventDefault()
                          handleDeleteIncident(index, incident?.diagnosis, incident?.date)
                        }}
                      >
                        <Trash className="text-danger" />
                      </span>
                      <span
                        variant="outline"
                        color="secondary"
                        onClick={(e) => {
                          e.stopPropagation()
                          e.preventDefault()
                          setCurrentIncidentIndex(index)
                          setFreetypeModal(true)
                          const incidentData = allIncidents[index]
                          const firstItem = incidentData?.incidents?.[0]

                          if (firstItem?.freeRemark) {
                            setNewFreeTypeText(firstItem.freeRemark) // set if it exists
                          } else {
                            setNewFreeTypeText('') // empty input if not available
                          }

                          setFreetypeModal(true)
                        }}
                      >
                        <FilePlus2 size={20} />
                      </span>
                    </div>
                  </div>
                </CAccordionHeader>
                <CAccordionBody style={{ border: '0.6px solid #989898', borderRadius: '10px' }}>
                  {/* {incident?.incidents.length > 0 ? (
                          <div>
                            {incident?.incidents?.[0]?.freeRemark && <p className="">{incident?.incidents?.[0]?.freeRemark}</p>}
                            {incident?.incidents.map((item, itemIndex) => (
                              <div key={item.id} className="mb-3">
                                <div className="d-flex items-center gap-1">
                                  <p>{itemIndex + 1}.</p>
                                  <p>{item?.label}</p>
                                </div>

                                {item.type === 'dropdown' && (
                                  <Select
                                    onChange={(e) => {
                                      setAllIncidents((prevData) => {
                                        const newData = [...prevData]
                                        const incidentCopy = { ...newData[index] }
                                        const updatedItems = [...incidentCopy.incidents]
                                        updatedItems[itemIndex] = {
                                          ...updatedItems[itemIndex],
                                          answer: e.value,
                                        }
                                        incidentCopy.incidents = updatedItems
                                        newData[index] = incidentCopy
                                        return newData
                                      })
                                    }}
                                    placeholder="Select an option"
                                    value={item.answer ? { value: item.answer, label: item.answer } : null}
                                    options={
                                      item.options?.map((opt) => ({
                                        value: opt.label,
                                        label: opt.label,
                                      })) || []
                                    }
                                  />
                                )}

                                <span className="d-block pt-2">
                                  <Graytextarea
                                    value={item.freeType}
                                    onChange={(e) => {
                                      setAllIncidents((prevData) => {
                                        const newData = [...prevData]
                                        const incidentCopy = { ...newData[index] }
                                        const updatedItems = [...incidentCopy.incidents]
                                        updatedItems[itemIndex] = {
                                          ...updatedItems[itemIndex],
                                          freeType: e.target.value,
                                        }
                                        incidentCopy.incidents = updatedItems
                                        newData[index] = incidentCopy
                                        return newData
                                      })
                                    }}
                                    height={'100px'}
                                    placeholder={'Freetype'}
                                  />
                                </span>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p>No Questions Available</p>
                        )} */}

                  {incident?.incidents.length > 0 ? (
                    <div>
                      {incident?.incidents?.[0]?.freeRemark && <p style={{ whiteSpace: 'pre-line' }}>{incident?.incidents?.[0]?.freeRemark}</p>}
                      {incident.incidents.map((item, itemIndex) => renderIncidentQuestion(item, index, itemIndex))}
                    </div>
                  ) : (
                    <p>No Questions Available</p>
                  )}
                </CAccordionBody>
              </CAccordionItem>
            )
          })}
      </CAccordion>
      <div className="d-flex align-items-center justify-content-center mt-2">
        <CButton
          color="primary"
          disabled={allIncidents.length === 0 && !incidentRemark}
          onClick={handleSave}
          className="ui-action-btn ui-action-btn--primary"
          style={{ minWidth: '96px' }}
        >
          {savingIncidentLocally ? <CSpinner size="sm" color="light" role="status" aria-hidden="true" /> : 'Save'}
        </CButton>
      </div>
      {/* <CModal className="incident-modal" centered visible={visible} size="lg" alignment="center" onClose={() => setVisible(false)}>
        <CModalHeader>
          <CModalTitle>Add Incident</CModalTitle>
        </CModalHeader>
        <CModalBody
          style={{
            height: '400px',
          }}
          className="d-flex  justify-content-center"
        >
          <div className="w-50 d-flex flex-column gap-3">
            <Select placeholder="Select Diagnosis" options={allDiagnosis} onChange={(e) => setSelectedDiagnosis(e.label)} value={allDiagnosis.find((item) => item.label === selectedDiagnosis) || null} />

            <div className="d-flex align-items-center gap-3">
              <CFormLabel className="fw-medium mb-0">Incident Date:</CFormLabel>
            
              <CustomDatePickingFormat value={date} onChange={handleDateChange} />
            </div>
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton
            variant="outline"
            onClick={() => {
              setVisible(false)
              setDate('')
              setSelectedDiagnosis(null)
            }}
            color="secondary"
          >
            Close
          </CButton>
          <CButton variant="outline" onClick={handleAddNewIncident}>
            {isAddingNewIncident ? 'Adding...' : 'Add Incident'}
          </CButton>
        </CModalFooter>
      </CModal> */}
      <CModal className="incident-modal" visible={visible} size="lg" alignment="center" onClose={() => setVisible(false)}>
        <CModalHeader
          style={{
            backgroundColor: '#282828',
            borderBottom: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
            color: 'white',
            position: 'relative',
          }}
          closeButton
          closeButtonProps={{ style: { filter: 'invert(1)' } }}
        >
          <CModalTitle
            style={{
              color: 'white',
              textAlign: 'center',
              width: '100%',
            }}
          >
            Add Incident
          </CModalTitle>
        </CModalHeader>

        <CModalBody
          style={{
            height: '380px',
            backgroundColor: '#282828',
            color: 'white',
          }}
          className="d-flex justify-content-center"
        >
          <div className="w-75 d-flex flex-column gap-3">
            <Select
              placeholder="Select Diagnosis"
              options={allDiagnosis}
              onChange={(e) => setSelectedDiagnosis(e.label)}
              value={allDiagnosis.find((item) => item.label === selectedDiagnosis) || null}
              styles={{
                control: (base, state) => ({
                  ...base,
                  backgroundColor: '#191919',
                  borderColor: state.isFocused ? '#444' : '#444',
                  borderRadius: '6px',
                  boxShadow: 'none',
                  '&:hover': { borderColor: '#444' },
                }),
                menu: (base) => ({
                  ...base,
                  backgroundColor: '#000',
                  borderRadius: '6px',
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected ? '#191919' : state.isFocused ? '#2a2a2a' : '#000',
                  color: 'white',
                  cursor: 'pointer',
                  padding: '12px 14px',
                  borderBottom: '1px solid #333',
                  ':last-of-type': { borderBottom: 'none' },
                  ':active': { backgroundColor: '#2a2a2a' },
                }),
                singleValue: (base) => ({ ...base, color: 'white' }),
                placeholder: (base) => ({ ...base, color: '#aaa' }),
                input: (base) => ({ ...base, color: 'white' }),
                dropdownIndicator: (base) => ({
                  ...base,
                  color: 'white',
                  ':hover': { color: 'white' },
                }),
              }}
            />

            <div className="d-flex  align-items-center justify-content-between gap-3">
              <CFormLabel className="fw-medium mb-0" style={{ color: 'white' }}>
                Incident Date:
              </CFormLabel>
              <div style={{ width: '400px' }}>
                <CustomDatePickingFormat
                  value={date}
                  onChange={handleDateChange}
                  className="dark-input"
                  style={{
                    backgroundColor: '#191919',
                    color: 'white',
                    border: '1px solid #444',
                    borderRadius: '6px',
                    padding: '4px 8px',
                  }}
                />
              </div>
            </div>
          </div>
        </CModalBody>

        <CModalFooter
          style={{
            backgroundColor: '#282828',
            borderTop: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            paddingTop: '10px',
          }}
        >
          <CButton
            onClick={handleAddNewIncident}
            style={{
              backgroundColor: 'var(--ui-color-primary, #2b7cd3)',
              border: 'none',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
          >
            {isAddingNewIncident ? 'Adding...' : 'Add Incident'}
          </CButton>
          <CButton
            onClick={() => {
              setVisible(false)
              setDate('')
              setSelectedDiagnosis(null)
            }}
            style={{
              backgroundColor: '#333',
              border: '1px solid gray',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
          >
            Close
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal
        visible={freetypeModal}
        size="lg"
        onClose={() => {
          setFreetypeModal(false)
          setNewFreeTypeText('')
        }}
        alignment="center"
      >
        <CModalHeader
          style={{
            backgroundColor: '#282828',
            borderBottom: '1px solid gray',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            position: 'relative',
          }}
        >
          <CModalTitle
            style={{
              color: 'white',
              textAlign: 'center',
              width: '100%',
            }}
          >
            Add Note
          </CModalTitle>
        </CModalHeader>
        <CModalBody
          style={{
            backgroundColor: '#282828',
            color: 'white',
          }}
        >
          <Graytextarea
            style={{
              backgroundColor: '#282828',
              color: 'white',
              border: '1px solid #989898',
              height: '200px',
            }}
            placeholder="Enter freetype"
            value={newFreeTypeText}
            rows={4}
            onChange={(e) => setNewFreeTypeText(e.target.value)}
          />
        </CModalBody>
        <CModalFooter
          style={{
            backgroundColor: '#282828',
            borderTop: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            paddingTop: '10px',
          }}
        >
          <CButton
            color="primary"
            variant="outline"
            style={{
              backgroundColor: '#4363F2',
              border: 'none',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            // onClick={() => {
            //     const textToBeAddInDiagnosis = allIncidents[currentIncidentIndex]
            //     if(textToBeAddInDiagnosis && textToBeAddInDiagnosis?.incidents && textToBeAddInDiagnosis?.incidents.length > 0){

            //     }else{
            //         toast.error("no incident there to add in index",toastConfig)
            //     }
            // }}
            onClick={() => {
              const updatedIncidents = [...allIncidents]
              const textToBeAddInDiagnosis = updatedIncidents[currentIncidentIndex]

              if (textToBeAddInDiagnosis?.incidents?.length > 0) {
                const original = textToBeAddInDiagnosis.incidents[0]

                const updatedFirstItem = {
                  ...original,
                  freeRemark: newFreeTypeText,
                }

                // Replace 0 index with updated version
                const newIncidentArray = [updatedFirstItem, ...textToBeAddInDiagnosis.incidents.slice(1)]

                updatedIncidents[currentIncidentIndex] = {
                  ...textToBeAddInDiagnosis,
                  incidents: newIncidentArray,
                }

                setAllIncidents(updatedIncidents)
                toast.success('Free remark added to first incident', toastConfig)
                setFreetypeModal(false)
                setNewFreeTypeText('')
              } else {
                toast.error('No incident available to update', toastConfig)
              }
            }}
          >
            Add
          </CButton>
          <CButton
            style={{
              backgroundColor: '#333',
              border: '1px solid gray',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            onClick={() => {
              setFreetypeModal(false)
              setNewFreeTypeText('')
            }}
          >
            Cancel
          </CButton>
        </CModalFooter>
      </CModal>
      {/* <CModal
        visible={toggleToAddIncidentRemark}
        size="lg"
        onClose={() => {
          setToggleToAddIncidentRemark(false)
        }}
      >
        <CModalHeader>
          <CModalTitle>Add Freetype</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Graytextarea placeholder="Enter freetype" value={tempModalIncidentRemark} rows={4} onChange={(e) => setTempModalIncidentRemark(e.target.value)} />
        </CModalBody>
        <CModalFooter>
          <CButton
            color="secondary"
            variant="outline"
            onClick={() => {
              setToggleToAddIncidentRemark(false)
              setTempModalIncidentRemark('')
            }}
          >
            Cancel
          </CButton>
          <CButton
            color="primary"
            variant="outline"
            onClick={() => {
              setToggleToAddIncidentRemark(false)
              setIncidentRemark(tempModalIncidentRemark)
              noteStructureRef.current = {
                ...noteStructureRef.current,
                incidentRemark: tempModalIncidentRemark,
              }
            }}
          >
            Add
          </CButton>
        </CModalFooter>
      </CModal> */}
      <CModal visible={toggleToAddIncidentRemark} size="lg" centered alignment="center" onClose={() => setToggleToAddIncidentRemark(false)}>
        <CModalHeader
          style={{
            backgroundColor: '#282828',
            borderBottom: '1px solid gray',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
          }}
          closeButton
          closeButtonProps={{ style: { filter: 'invert(1)' } }}
        >
          <CModalTitle style={{ color: 'white' }}>Add Freetype</CModalTitle>
        </CModalHeader>

        <CModalBody
          style={{
            backgroundColor: '#282828',
            color: 'white',
          }}
        >
          <Graytextarea
            style={{
              backgroundColor: '#191919',
              color: 'white',
              border: '1px solid #444',
              height: '200px',
            }}
            placeholder="Enter freetype"
            value={tempModalIncidentRemark}
            className=" "
            onChange={(e) => setTempModalIncidentRemark(e.target.value)}
          />
        </CModalBody>

        <CModalFooter
          style={{
            backgroundColor: '#282828',
            borderTop: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            padding: '10px',
          }}
        >
          <CButton
            style={{ backgroundColor: 'var(--ui-color-primary, #2b7cd3)', color: 'white', border: 'none' }}
            onClick={async () => {
              setToggleToAddIncidentRemark(false)
              setIncidentRemark(tempModalIncidentRemark)
              noteStructureRef.current = {
                ...noteStructureRef.current,
                incidentRemark: tempModalIncidentRemark,
              }
              await handleAddFreeRemarkOffline(tempModalIncidentRemark)
            }}
          >
            Add
          </CButton>
          <CButton
            style={{ backgroundColor: '#333', color: 'white', border: 'none' }}
            onClick={() => {
              setToggleToAddIncidentRemark(false)
              setTempModalIncidentRemark('')
            }}
          >
            Cancel
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ProviderIncidentTab
